// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const config = {
  production: false,
  enableServiceWorker: false,
  environmentName: 'DEV',
  enableErrorReporting: true,
  sandboxFeatureGuide: true,
  azureAd: {
    clientId: '70f28028-6912-44b8-a718-696bcec36aee',
    authority: 'https://ndcexternaluat.ciamlogin.com/bf9127e4-0ba0-4880-a4dc-81acd64d1a9f',
    redirectUri: 'https://dt3xofmwfgbi4.cloudfront.net/home',
    postLogoutRedirectUri: 'https://dt3xofmwfgbi4.cloudfront.net/home',
    scopes: ['openid', 'profile', 'email', 'user.read'],
    apiScope: 'api://92b2e817-7fef-4f4f-b633-00bc74ad5278/portal'
  },
  graph: {
    apiEndpoint: 'https://graph.microsoft.com/',
    meEndpoint: 'https://graph.microsoft.com/v1.0/me',
    editProfileScope: 'api://70f28028-6912-44b8-a718-696bcec36aee/EditProfileService.ReadWrite'
  },
  gaTrackingId: 'UA-249071319-1',
  hotjarSettings: {
    hjid: 3248122,
    hjsv: 6
  },
  enableCookies: true,
  contentful: {
    spaceId: 'nwnmkeyu03hy',
    token: 'iz6ODyxbbCBfo-k9ZyXNCtWfr2I2nx2ZWPfnrywr1uw',
    environment: 'master',
    host: 'preview.contentful.com'
  },
  new_project_url: '/ndcportal/index.html',
  oneTrust: {
    srcUrl: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
    dataDomainScript: '0196f7c0-964f-7e3d-a289-c6c94aebf0a0-test'
  },
  sessionTimeout: 2 * 60 * 60 * 1000 // 2 hours in milliseconds

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
